
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from 'App';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Material Dashboard 2 PRO React TS Context Provider
import { MaterialUIControllerProvider } from 'context';
import { Provider } from 'react-redux';
import { store } from 'store/Store';
import { Suspense } from 'react';
import './index.css';

ReactDOM.render(
	<Provider store={store}>
		<Suspense
			fallback={
				<div>
					<h1>Cargando...</h1>
				</div>
			}
		>
			<BrowserRouter>
				<MaterialUIControllerProvider>
					<App />
					{/* Global toast container above modals/backdrops */}
					<ToastContainer
						position='top-right'
						autoClose={3000}
						hideProgressBar
						newestOnTop={false}
						closeOnClick
						rtl={false}
						pauseOnFocusLoss
						draggable
						pauseOnHover
						style={{ zIndex: 20000 }}
					/>
				</MaterialUIControllerProvider>
			</BrowserRouter>
		</Suspense>
	</Provider>,
	document.getElementById('root')
);
